import { appStrings } from "utils/appStrings";

export interface QuizItemProps {
  title: string;
  image?: string;
  onClick: () => void;
}

const QuizItem: React.FC<QuizItemProps> = ({ title, image, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="w-full h-full bg-white border-2 border-gray-100 rounded-3xl py-6 px-6 flex flex-col space-y-6 select-none group transition duration-300 cursor-pointer shadow-sm hover:shadow-xl dark:bg-gray-800 dark:border-gray-600"
    >
      <img className="w-36 mx-auto" src={image} alt={title} />
      <div>
        <p className="font-bold text-lg text-gray-800 text-center transition duration-300 group-hover:text-primary-800 dark:text-secondary-300 dark:group-hover:text-primary-300">
          {title}
        </p>
        <p className="text-primary-500 font-semibold text-center text-sm mt-2 dark:text-gray-300">
          {appStrings.start}
        </p>
      </div>
    </div>
  );
};

export default QuizItem;
